import { render, staticRenderFns } from "./ActivationBriefOrderView.vue?vue&type=template&id=71ece7e6&"
import script from "./ActivationBriefOrderView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports